import { faDiamond } from "@jewlr/sharp-solid-svg-icons/faDiamond"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { jewlr_t } from "helpers/application"

import WizardLoading from "./loaders/wizard-loading"
import AccordionContent from "./wizard-options/accordion-content"
import AccordionHeading from "./wizard-options/accordion-heading"

const InternalWizardOptions = ({ adminMode, prefOrder, wizardLoading }) => (
  <div className="border-t-grey-400 tablet:border-none overflow-hidden border-t">
    <Media className="flex items-center py-12" lessThan="tablet">
      <FontAwesomeIcon className="text-12 text-primary mr-6" icon={faDiamond} />
      <h2 className="text-16 font-semibold">
        {jewlr_t("terms.Personalize")} It
      </h2>
    </Media>
    {wizardLoading ? (
      <WizardLoading />
    ) : (
      prefOrder
        .filter((pref) => !(adminMode && pref == "gift"))
        .map((pref) => (
          <div data-cy={`wizard-accordion-${pref}`} key={`wopt-${pref}`}>
            <AccordionHeading pref={pref} />
            <AccordionContent panel={pref} pref={pref} />
          </div>
        ))
    )}
  </div>
)

InternalWizardOptions.propTypes = {
  adminMode: PropTypes.bool,
  prefOrder: PropTypes.array,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    adminMode: state.wizard.adminMode,
    prefOrder: state.wizard.prefOrder,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => {
  return {}
}

const WizardOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalWizardOptions)

export default WizardOptions
